// The words for a failed request, shared by the pay screens and Getting started: what the server said, else the
// error's own message, else the fallback. (The button, card and field looks that used to live here are now the
// shared components in Ui/index.jsx.)
export const errorText = (err, fallback) => err?.payload?.message || err?.payload?.detail || err?.message || fallback;
